// 这个文件是用来整合组件的
import _Upload from "./src/upload.vue";
import { withInstall } from "@chenms-zj/utils/with-install";

const Upload = withInstall(_Upload);

// 可以通过app.use来使用 也可以通过import的方式单独使用
export default Upload;

export * from "./src/upload";

// 这里添加的类型，可以在模板中被解析
declare module "vue" {
  // 我们的接口可以自动合并
  export interface GlobalComponents {
    "cms-upload": typeof Upload;
  }
}
